// extracted by mini-css-extract-plugin
module.exports = {"Prompt":"S1sOlmOG2tU+z0QMruxYqA=="};